import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "./__root.js";

export const bookRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/book/$ownerSlug/$eventTypeSlug",
  component: lazyRouteComponent(() => import("./book.page.js"), "BookingPage"),
});
